import { DeliveryEventNotificationHistoryPostableType } from "~/domains";

import { ManagerRole, OwnerRole } from "~/domains/EmployeeProfile";

type UrlReadMutateMappingType = {
  [key: string]: {
    postableType: DeliveryEventNotificationHistoryPostableType;
    employeeRoleId?: typeof ManagerRole.id | typeof OwnerRole.id;
  };
};

export const urlReadMutateMapping: UrlReadMutateMappingType = {
  "/": {
    postableType: "InsightPost",
  },
  "/insight_posts": {
    postableType: "InsightPost",
  },
  "/managers": {
    postableType: "InsightPost",
  },
  "/managers/feedback/insight_posts": {
    postableType: "InsightPost",
  },
  "/kaizen_ideas": {
    postableType: "KaizenIdea",
  },
  "/input_employee_surveys": {
    postableType: "EmployeeSurveySubmission",
  },
  "/managers/employee_survey_submissions": {
    postableType: "EmployeeSurveySubmission",
  },
  "/managers/feedback/kaizen_ideas": {
    postableType: "KaizenIdea",
  },
  "/kpi_terms": {
    postableType: "KpiTerm",
  },
  "/knowledge_post/team": {
    postableType: "InsightPostSharedEmployee",
  },
  "/managers/knowledge_post/team": {
    postableType: "InsightPostSharedEmployee",
  },
  "/knowledge_post/manager": {
    postableType: "KnowledgeInsightPost",
    employeeRoleId: ManagerRole.id,
  },
  "/managers/knowledge_post/manager": {
    postableType: "KnowledgeInsightPost",
    employeeRoleId: ManagerRole.id,
  },
  "/knowledge_post/owner": {
    postableType: "KnowledgeInsightPost",
    employeeRoleId: OwnerRole.id,
  },
  "/managers/knowledge_post/owner": {
    postableType: "KnowledgeInsightPost",
    employeeRoleId: OwnerRole.id,
  },
  "/document_file_category/manager": {
    postableType: "DocumentFileCategory",
    employeeRoleId: ManagerRole.id,
  },
  "/document_file_category/owner": {
    postableType: "DocumentFileCategory",
    employeeRoleId: OwnerRole.id,
  },
  "/question_answer_category/manager": {
    postableType: "QuestionAnswerCategory",
    employeeRoleId: ManagerRole.id,
  },
  "/question_answer_category/owner": {
    postableType: "QuestionAnswerCategory",
    employeeRoleId: OwnerRole.id,
  },
  "/skill_evaluation_standard_summary_categories": {
    postableType: "SkillEvaluationStandardSummaryCategory",
  },
  "/skill_evaluation_terms": {
    postableType: "SkillEvaluationTerm",
  },
  "/sales_concept_categories/manager": {
    postableType: "SalesConceptCategory",
    employeeRoleId: ManagerRole.id,
  },
  "/sales_concept_categories/owner": {
    postableType: "SalesConceptCategory",
    employeeRoleId: OwnerRole.id,
  },
} as const;
